var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgClockRed = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 46,
  height: 46,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FB5656",
  d: "M22.998 6.393a16.607 16.607 0 1 0 0 33.214 16.607 16.607 0 0 0 0-33.214",
  opacity: 0.3
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FB5656",
  d: "m29.087 31.674-7.935-7.935V11.93h3.69v10.334l6.828 6.827z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#FB5656",
  d: "M23 41.452c-10.15 0-18.453-8.304-18.453-18.453S12.85 4.547 22.999 4.547s18.453 8.303 18.453 18.452-8.304 18.453-18.453 18.453m0-33.215C14.88 8.237 8.236 14.88 8.236 23S14.88 37.761 23 37.761 37.761 31.118 37.761 23 31.118 8.237 23 8.237"
})));
export default SvgClockRed;